<template>
  <div class="embed-table">
    <div class="mount-point" v-html="content"></div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
export default {
  name: 'embed-table',
  components: {
  },
  props: {
    content: VueTypes.string.isRequired
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    formatContent (text) {
      if (typeof text !== 'string') return ''
      const isGeekbang = /^http[s]?:\/\/(([a-zA-Z0-9_-])+(\.))?\b(infoq\.(cn|com)|geekbang\.(org|com))\b($|\/[^\s]*)/i

      const REG = /https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*/ig
      text = text.replace(/<([^>]*)>/g, '&lt;$1&gt;') //  将html标签 转义 防注入
      text = text.replace(/\n/g, '<br />') // 回车符替换成 br 标签
      text = text.replace(REG, function (url) {
        return isGeekbang.test(url) ? `<a href="${url}" target="_blank" rel="noopener nofollow">${url}</a>` : url
        // if (checkGeekbang) {
        //   return isGeekbang.test(url) ? `<a href="${url}" target="_blank" rel="noopener nofollow">${url}</a>` : url
        // } else {
        //   return `<a href="${url}" target="_blank" rel="noopener nofollow">${url}</a>`
        // }
      })
      return text
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/css/_common';
.embed-table {
  overflow-x: auto;
}
.embed-table .mount-point {
  table {
    width: 100%;
    border-collapse: separate;
  }

  table th,
  table td,
  th,
  td,
  table caption {
    text-align: center;
    border: 1px solid #E2E5E7;
    padding: 18px 16px;
  }

  thead tr,
  thead {
    & th {
      padding: 18px 16px;
      background: #F7F7F7;
      border-bottom: none;
      border-right: none;
      @include font(16, 500);
      color: $lightBlack;
      line-height: 21px;
    }
    & th:first-child {
      border-radius: 4px 0 0 0;
    }
    & th:last-child {
      border-radius: 0 4px 0 0;
      border-right: 1px solid #E2E5E7;
    }
  }

  tbody tr:last-child {
    & td:first-child {
      border-radius: 0 0 0 4px;
    }
    & td:last-child {
      border-radius: 0 0 4px 0;
    }
  }

  table caption {
    border-bottom: none;
  }

  tbody tr {
    td {
      border-right: none;
      @include font(16, 400);
      line-height: 24px;
      color: $lightBlack;

      &:last-child {
        border-right: 1px solid #E2E5E7;
      }
    }
  }

  tbody tr:not(:last-child) {
    & td {
      border-bottom: none;
    }
  }
}
</style>
